<template>
  <div>
    <el-upload
      :action="uploadUrl"
      name="file"
      ref="upload"
      list-type="picture-card"
      :file-list="imgList"
      :on-preview="handlePictureCardPreview"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :headers="myHeaders"
    >
      <i class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
              @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <div slot="tip" class="el-upload__tip">{{ tipText }}</div>
    <el-dialog :visible.sync="dialogVisible">
      <img
        width="100%"
        :src="dialogImageUrl"
        alt
        style="height：150px;width:150px"
      />
    </el-dialog>
  </div>
</template>
<script>
/**
 * 图片上传组件（el-upload picture-card）
 * 功能：校验 jpg/jpeg/png/gif 且不超过 20M，成功后回传 URL
 */
import config from "@/config/config";
const rootApi = config.serverPath.server;
import { getToken } from "@/utils/cookies";
export default {
  props: {
    imgList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    nowStatus: {
      type: String,
      default: "",
    },
    tipText: {
      type: String,
      default: "支持文件格式jpg，jpeg，png，gif，且不超过20M",
    },
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      upload: true,
      uploadUrl: rootApi + "/common/upload/images",
      myHeaders: {
        "X-CSRF-TOKEN": getToken(),
      },
    };
  },
  methods: {
    /** 点击图片预览大图 */
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeUpload(data) {
      this.file = data; //上传文件变化时将文件对象push进files数组
      var fileName = new Array();
      fileName = this.file.name.split(".");
      const extension = fileName[fileName.length - 1];
      const isLt2M = this.file.size / 1024 / 1024 < 20;
      if (
        extension != "jpg" &&
        extension != "png" &&
        extension != "jpeg" &&
        extension != "gif"
      ) {
        this.$message({
          message: "图片格式为格式 “jpg”, “jpeg”, “png”, “gif”",
          type: "warning",
        });
        this.$refs.upload.clearFiles();
        this.upload = false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传模板大小不能超过 20MB!",
          type: "warning",
        });
        this.$refs.upload.clearFiles();
        this.upload = false;
      }
      return this.upload;
    },
    /** 上传成功后将图片 URL 追加到列表并通知父组件 */
    handleSuccess(result) {
      if (result.code == 200) {
        this.imgList.push(result.data.url);
        this.$emit("getImgUrl", result.data);
      } else {
        this.$message({
          message: "上传失败",
          type: "warning",
        });
        this.$refs.upload.clearFiles();
      }
    },
  },
};
</script>

<style>
</style>